var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    id: "svg150",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs154"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 0.0492955,8.7659309 c -0.0038698,0.1758153 0.0471177,0.3485836 0.14595416,0.4941315 0.0988365,0.1455479 0.24062631,0.256664 0.40554334,0.3179099 0.16490687,0.061348 0.34479515,0.069676 0.5146789,0.02397 0.1698939,-0.045706 0.3212515,-0.1432118 0.43317,-0.2789075 L 5.9856484,4.1437444 10.421081,9.323035 c 0.06907,0.093849 0.156619,0.1725651 0.257477,0.2309671 0.100756,0.058402 0.212583,0.095474 0.328371,0.1086785 0.115788,0.013306 0.232999,0.00244 0.344419,-0.031689 0.111421,-0.034229 0.214615,-0.091006 0.303081,-0.1668774 0.08847,-0.075872 0.160174,-0.1692133 0.210857,-0.2741338 0.05068,-0.1049204 0.07912,-0.2191851 0.08369,-0.3356844 0.0045,-0.1163977 -0.01503,-0.2324906 -0.05749,-0.3410675 C 11.848933,8.4047527 11.784539,8.3061296 11.702268,8.2236558 L 6.6287101,2.2938846 C 6.5492834,2.2007563 6.4506602,2.1259814 6.3394425,2.0747096 6.2283264,2.0234377 6.1072566,1.9968877 5.9848663,1.9968877 c -0.1224207,0 -0.2434093,0.02655 -0.3545762,0.077822 -0.1111668,0.051272 -0.2098916,0.1260467 -0.2893589,0.219175 L 0.26251858,8.2236558 C 0.12946364,8.3734696 0.0538153,8.5656375 0.04910252,8.7659309 Z",
    fill: "#283856",
    id: "path148",
    style: {
      strokeWidth: 1.01569
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/ChevronUp.64577aa8ed86feef448e68c7df0bde80.svg";
export { ForwardRef as ReactComponent };